import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import styles from "./addproduct.module.scss";
import Proptypes from "prop-types";
import { toast } from "react-toastify";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import EPCWarningModal from "./EPCWarningModal";
import { addProduct, editProduct } from "../../../../helpers/service";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { setProducts } from "../../../Redux/Reducer/appReducer";

const AddProductSchema = yup.object().shape({
  Name: yup.string().required("Name is required"),
  price: yup.number().required("Price is required"),
  Brand: yup.string().required("Brand is required"),
  Category: yup.string().required("Brand is required"),
  GlobalTradeItemNumber: yup.string().required("GTIN is required"),
  Description: yup.string().required("Description is required"),
});

const AddProductModal = ({
  openModal,
  toggle,
  productData,
  setLoading,
  categories,
}) => {
  const productsData = useSelector((state) => state?.appReducer)?.products;
  const { id } = useSelector((state) => state?.authReducer);

  const productId = productData?.id || "";
  const isEdit = productData ? true : false;
  const dispatch = useDispatch();

  const fetchImageAsFile = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const file = new File([blob], "image.jpg", { type: blob.type });
      return file;
    } catch (error) {
      // Handle CORS error or other fetch errors
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const parseThroughFiles = async () => {
    const filesUrls = productData?.images;
    if (!filesUrls.length) return [];
    const fileURLArray = [];
    for (const url of filesUrls) {
      const obj = await fetchImageAsFile(url);
      fileURLArray.push(obj);
    }
    return fileURLArray;
  };

  const initialState = {
    Name: productData?.name || "",
    price: productData?.price || "",
    brandID: productData?.brandId || productData?.brandID || "",
    Brand: productData?.brand || "",
    Category: productData?.category || "",
    Description: productData?.description || "",
    Images: [],
    Colors: productData?.colors || "red",
    Weight: productData?.weight || "",
    ExpirationTime: productData?.expirationTime || "2025-12-31T23:59:59Z",
    GlobalTradeItemNumber: productData?.globalTradeItemNumber || "",
    Ingredients: productData?.Ingredients || "",
    ReturnPolicy: productData?.returnPolicy || "",
    SafetyInformation: productData?.safetyInformation || "",
    WarrantyGuaranteeDetails:
      productData?.warrantyGuaranteeDetails || "1-year warranty",
    ShippingInformation: productData?.shippingInformation || "",
    Certifications: productData?.certifications || "",
    productURL: productData?.productURL || "",
    country: productData?.country || "",
    userId: productData?.userId || id,
  };
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: AddProductSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const [step, setStep] = useState(0);
  const [showEPCWarning, setShowEPCWarning] = useState(false);

  const handleChange = (e) => {
    formik.handleChange(e);
  };

  const handleSubmit = async (formData) => {
    try {
      const { Images, ...formValues } = formData;
      const files = Images;

      if (isEdit) {
        setLoading(true);
        const responseData = await editProduct(formValues, productId, files);
        const newProducts = productsData.map((product) => {
          if (product.id === productId) {
            setLoading(false);
            return {
              ...productData,
              ...responseData?.data,
              id: productId || "",
            };
          }
          return product;
        });
        dispatch(setProducts(newProducts));
        toast.success("Product updated successfully");
        setStep(step + 1);
        formik.resetForm();
        toggle();
        return;
      } else {
        setLoading(true);
        const responseData = await addProduct(formValues, files);
        const newProducts = [
          ...productsData,
          {
            ...responseData?.data,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
        ];
        dispatch(setProducts(newProducts));
        setLoading(false);
        toast.success("Product added successfully");
        setStep(step + 1);
        formik.resetForm();
        toggle();
      }
    } catch {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  };
  const setFileValue = async () => {
    const files = await parseThroughFiles();
    formik?.setFieldValue("Images", files);
  };

  useEffect(() => {
    if (productData) {
      setFileValue();
    }
  }, [productData]);
  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={
          step === 0
            ? styles["modal_product_container"]
            : step === 1 || step === 2
            ? styles["steptwo_stepthree_container"]
            : ""
        }
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_location_body"]}>
          {step === 3 && showEPCWarning ? (
            <>
              <EPCWarningModal
                toggle={toggle}
                handleSubmit={() => {
                  formik.handleSubmit();
                }}
              />
            </>
          ) : (
            <>
              {step === 0 ? (
                <StepOne
                  handleChange={handleChange}
                  setStep={setStep}
                  step={step}
                  toggle={toggle}
                  formData={formik}
                  isEdit={isEdit}
                  categories={categories}
                />
              ) : step === 1 ? (
                <StepTwo
                  handleChange={handleChange}
                  setStep={setStep}
                  step={step}
                  toggle={toggle}
                  formData={formik}
                  isEdit={isEdit}
                />
              ) : (
                <StepThree
                  handleChange={handleChange}
                  setStep={setStep}
                  step={step}
                  toggle={toggle}
                  // handleSubmit={() => {
                  //   formik.submitForm();
                  // }}
                  handleSubmit={() => {
                    formik.handleSubmit();
                  }}
                  setShowEPCWarning={setShowEPCWarning}
                  formData={formik}
                  isEdit={isEdit}
                />
              )}
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

AddProductModal.propTypes = {
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
  productData: Proptypes.object,
};

export default AddProductModal;
